

export function RevertAllChangesButton({...params}){
    let handleRevertAllChangesClick = params.handleRevertAllChangesClick


    return (
        <button onClick={(event) => handleRevertAllChangesClick(event)}>RevertAllChanges</button>
    )

}